const desc = (a, b) => b.length - a.length;

function detect({ text, detected}, phrase) {
  return {
    text,
    detected: detected ? detected : match(phrase).test(text)
  }
}
function match(phrase) {
  return new RegExp(`\\b${phrase}\\b`, 'gi');
}
function censor(text, phrase) {
  const asterisks = phrase.replace(/\w/gi, '*');
  return text.replace(match(phrase), asterisks);
}
function create(list) {
  const sortedList = list.sort(desc);
  return {
    clean(text) {
      return sortedList.reduce(censor, text);
    },

    hasPhrase(text) {
      const { detected } = sortedList.reduce(detect, { text, detected: false });
      return detected;
    }
  }
}

export { censor, create, detect, match };
